export default "__VITE_ASSET__0516af4d__"